<template>
    <v-row no-gutters class="my-0 py-0 px-2">
        <v-col cols="12">
            <v-card v-if="type !== 'cup'" class="text-left white--text mb-2 mt-2 rounded-0" color="teal">
                <v-card-title style="font-size: 40px; padding-left: 10px; margin: 0;">TOP PERFORMERS</v-card-title>
                <v-row class="px-1">
                    <v-col cols="12" lg="4">
                        <div style="font-size: 30px; padding-left: 10px; margin: 0;">TOP SCORER</div>
                        <v-data-table
                            :headers="topPointsHeaders"
                            :items="topPerformers.topScorePlayers"
                            class=" py-3 font-weight-bold"
                            hide-default-footer
                            disable-sort
                            :mobile-breakpoint="0"
                            :items-per-page="-1"
                            style="background: #232323;"
                            dark
                        >
                            <template v-slot:item.player="{ item }">
                                <v-row dense align="center" justify="center">
                                    <v-col cols="12" align="start" class="py-2">
                                        <img
                                            :src="`${assetsUrl}/${item.imgUrl}`"
                                            height="auto"
                                            width="50px"
                                            contain
                                            class="mr-2"
                                            style="display: inline-flex;"
                                            @error="$event.target.src = defaultPlayerImg"
                                        >
                                        <div>{{ `${item.name}` }}</div>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-slot:item.team="{ item }">
                                <v-row dense align="center" justify="center">
                                    <v-col cols="12" align="start" class="py-2">
                                        <v-avatar style="border-radius: 10px;" size="50" color="white">
                                            <img
                                                :src="`${assetsUrl}/${item.teamLogoUrl}`"
                                                height="auto"
                                                width="50px"
                                                contain
                                                style="display: inline-flex;"
                                            >
                                        </v-avatar>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" lg="4">
                        <div style="font-size: 30px; padding-left: 10px; margin: 0;">THE BOMBER</div>
                        <v-data-table
                            :headers="topThreePointsMadeHeaders"
                            :items="topPerformers.topThreePointsMadePlayers"
                            class=" py-3 font-weight-bold"
                            hide-default-footer
                            disable-sort
                            :mobile-breakpoint="0"
                            :items-per-page="-1"
                            style="background: #232323;"
                            dark
                        >
                            <template v-slot:item.player="{ item }">
                                <v-row dense align="center" justify="center">
                                    <v-col cols="12" align="start" class="py-2">
                                        <img
                                            :src="`${assetsUrl}/${item.imgUrl}`"
                                            height="auto"
                                            width="50px"
                                            contain
                                            class="mr-2"
                                            style="display: inline-flex;"
                                            @error="$event.target.src = defaultPlayerImg"
                                        >
                                        <div>{{ `${item.name}` }}</div>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-slot:item.team="{ item }">
                                <v-row dense align="center" justify="center">
                                    <v-col cols="12" align="start" class="py-2">
                                        <v-avatar style="border-radius: 10px;" size="50" color="white">
                                            <img
                                                :src="`${assetsUrl}/${item.teamLogoUrl}`"
                                                height="auto"
                                                width="50px"
                                                contain
                                                style="display: inline-flex;"
                                            >
                                        </v-avatar>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" lg="4">
                        <div style="font-size: 30px; padding-left: 10px; margin: 0;">THE EFFICIENT</div>
                        <v-data-table
                            :headers="topEfficientHeaders"
                            :items="topPerformers.topPirPlayers"
                            class=" py-3 font-weight-bold"
                            hide-default-footer
                            disable-sort
                            :mobile-breakpoint="0"
                            :items-per-page="-1"
                            style="background: #232323;"
                            dark
                        >
                            <template v-slot:item.player="{ item }">
                                <v-row dense align="center" justify="center">
                                    <v-col cols="12" align="start" class="py-2">
                                        <img
                                            :src="`${assetsUrl}/${item.imgUrl}`"
                                            height="auto"
                                            width="50px"
                                            contain
                                            class="mr-2"
                                            style="display: inline-flex;"
                                            @error="$event.target.src = defaultPlayerImg"
                                        >
                                        <div>{{ `${item.name}` }}</div>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-slot:item.team="{ item }">
                                <v-row dense align="center" justify="center">
                                    <v-col cols="12" align="start" class="py-2">
                                        <v-avatar style="border-radius: 10px;" size="50" color="white">
                                            <img
                                                :src="`${assetsUrl}/${item.teamLogoUrl}`"
                                                height="auto"
                                                width="50px"
                                                contain
                                                style="display: inline-flex;"
                                            >
                                        </v-avatar>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
        <v-col cols="12" class="white  px-2 py-5 mb-5" align="center">
            <v-row style="background: #232323;">
                <v-col cols="12" align="center">
                    <v-chip-group
                        v-model="option"
                        column
                        mandatory
                        style="display: inline-block;"
                    >
                        <v-chip
                            v-for="(item, index) in ['Παίκτες', 'Ομάδα']"
                            :key="index"
                            filter
                            filter-icon="mdi-basketball-hoop"
                            active-class="custom-teal selected-chip"
                            color="white"
                            large
                            mandatory
                            class="font-weight-bold"
                        >
                            {{ item }}
                        </v-chip>
                    </v-chip-group>
                </v-col>
            </v-row>
        </v-col>
        <v-col v-for="(statHeader, index) in statsHeaders" :key="index" cols="12" md="6" class="mb-5 px-1">
            <stat-card :loading="loading" :stat-header="statHeader" :stats="getDisplayData(statHeader)" :option="option === 1" @scrollToStats="scrollToStats()" />
        </v-col>
        <v-col ref="stats" cols="12" class="white " align="center">
            <v-chip-group
                v-model="option2"
                column
                mandatory
                style="display: inline-block;"
            >
                <v-chip
                    v-for="(item, index) in ['Μέσοι Όροι', 'Σύνολο']"
                    :key="index"
                    filter
                    filter-icon="mdi-basketball-hoop"
                    active-class="custom-teal selected-chip"
                    color="white"
                    large
                    mandatory
                    class="font-weight-bold"
                >
                    {{ item }}
                </v-chip>
            </v-chip-group>
        </v-col>
        <v-col cols="12">
            <players-stats v-if="!option" :players="playerStats" :option="option2" :generic="true" />
            <teams-stats v-else :teams="stasData" :option="option2" :generic="true" />
        </v-col>
    </v-row>
</template>

<script>
    import StatCard from '@/components/StatCard'
    import statsService from '@/services/stats.js'
    import playerService from '@/services/player.js'
    import PlayersStats from '@/components/PlayersStats'
    import TeamsStats from '@/components/TeamsStats'

    export default {
        components: { StatCard, PlayersStats, TeamsStats },
        props: {
            league: {
                type: Object,
                required: true
            },
            season: {
                type: Number,
                required: true
            },
            type: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                defaultPlayerImg: require('@/assets/default_player.png'),
                assetsUrl: 'https://storage.googleapis.com',
                topPointsHeaders: [
                    { text: 'Player', value: 'player' },
                    { text: 'Team', value: 'team' },
                    { text: 'PTS', value: 'score' }
                ],
                topThreePointsMadeHeaders: [
                    { text: 'Player', value: 'player' },
                    { text: 'Team', value: 'team' },
                    { text: '3FGM', value: 'threePointsMade' }
                ],
                topEfficientHeaders: [
                    { text: 'Player', value: 'player' },
                    { text: 'Team', value: 'team' },
                    { text: 'EFF', value: 'pir' }
                ],
                statsHeaders: [
                    { text: 'PTS', value: 'points' },
                    { text: '2P Made', value: 'twoPointsMade' },
                    { text: '3P Made', value: 'threePointsMade' },
                    { text: 'FT Made', value: 'freeThrowsMade' },
                    { text: 'OR', value: 'offensiveRebounds' },
                    { text: 'DR', value: 'defensiveRebounds' },
                    { text: 'TR', value: 'rebounds' },
                    { text: 'AST', value: 'assists' },
                    { text: 'STL', value: 'steals' },
                    { text: 'TO', value: 'turnovers' },
                    { text: 'BLK', value: 'blockedShots' },
                    { text: 'FC', value: 'personalFouls' }
                ],
                stasData: null,
                playerStats: [],
                teamStats: [],
                option: 0,
                option2: 0,
                phase: 'regular_season',
                loading: false,
                maxRound: 0,
                topPerformers: []
            }
        },
        watch: {
            league: {
                handler() {
                    this.fetchStats()
                    if (this.type !== 'cup') {
                        this.getTopPlayers()
                    }
                }
            },
            phase: {
                handler() {
                    this.fetchStats()
                }
            }
        },
        created() {
            this.fetchStats()
            if (this.type !== 'cup') {
                this.getTopPlayers()
            }
        },
        methods: {
            getTopPlayers() {
                playerService.getTopPerformersByLeague(this.league.id, this.season).then(resp => {
                    this.topPerformers = resp.data
                })
            },
            getDisplayData(statHeader) {
                if (this.maxRound > 0) {
                    const temp = JSON.parse(JSON.stringify(this.option === 1 ? this.statsData : this.playerStats.filter((element) => {
                        return element.stats.length >= (this.maxRound * 0.55)
                    })))
                    temp.sort((a, b) => b.avg[statHeader.value] - a.avg[statHeader.value])
                    return temp.length > 5 ? temp.slice(0, 5) : temp
                } else {
                    return []
                }
            },
            fetchStats() {
                if (this.season) {
                    this.loading = true
                    this.$store.dispatch('setLeagueFilter', this.league)
                    if (this.type === 'cup') {
                        statsService.getStatsByCupLeague(this.league.id, this.season).then(resp => {
                            this.statsData = resp.data
                            this.calculateTeamsStats(resp.data)
                            this.calculatePlayersStats(resp.data)
                            this.getPlayersStats()
                        })
                    } else {
                        statsService.getStatsByLeague(this.league.id, this.phase, this.season).then(resp => {
                            this.statsData = resp.data
                            this.calculateTeamsStats(resp.data)
                            this.calculatePlayersStats(resp.data)
                            this.getPlayersStats()
                        })
                    }
                }
            },
            calculateTeamsStats(data) {
                data.forEach(team => {
                    this.teamStats = []
                    team.players.forEach(player => {
                        this.teamStats = this.teamStats.concat(player.stats)
                    })
                    team.stats = this.groupByMatch()
                    team.avg = this.getAverageStats(team)
                    team.cum = this.getCummulativeStats(team)
                    team.gp = team.stats.length
                    if (team.stats.length > this.maxRound) {
                        this.maxRound = team.stats.length
                    }
                })
                this.stasData = data
            },
            findMatches() {
                const matches = new Set()
                this.teamStats.forEach(stat => {
                    matches.add(stat.matchId)
                })
                return matches
            },
            groupByMatch() {
                const matches = this.findMatches()
                const data = []
                matches.forEach(match => {
                    const stats = {
                        points: 0,
                        rebounds: 0,
                        assists: 0,
                        steals: 0,
                        turnovers: 0,
                        blockedShots: 0,
                        twoPointsMade: 0,
                        twoPointAttempts: 0,
                        threePointsMade: 0,
                        threePointAttempts: 0,
                        freeThrowsMade: 0,
                        freeThrowAttempts: 0,
                        offensiveRebounds: 0,
                        defensiveRebounds: 0,
                        personalFouls: 0
                    }
                    this.teamStats.forEach(stat => {
                        if (match === stat.matchId) {
                            for (const key of Object.keys(stats)) {
                                stats[key] += stat[key]
                            }
                        }
                    })
                    data.push(stats)
                })
                return data
            },
            getPlayersStats() {
                this.playerStats = []
                this.stasData.forEach(team => {
                    this.playerStats = this.playerStats.concat(team.players)
                })
                this.loading = false
                return this.playerStats
            },
            calculatePlayersStats(data) {
                data.forEach(team => {
                    team.players.forEach(player => {
                        player.team = team.name
                        player.teamLogo = team.logo
                        player.avg = this.getAverageStats(player)
                        player.cum = this.getCummulativeStats(player)
                    })
                })
                this.stasData = data
            },
            getCummulativeStats(entity) {
                const stats = {
                    points: 0,
                    rebounds: 0,
                    assists: 0,
                    steals: 0,
                    turnovers: 0,
                    blockedShots: 0,
                    twoPointsMade: 0,
                    twoPointAttempts: 0,
                    threePointsMade: 0,
                    threePointAttempts: 0,
                    freeThrowsMade: 0,
                    freeThrowAttempts: 0,
                    offensiveRebounds: 0,
                    defensiveRebounds: 0,
                    personalFouls: 0,
                    playTimeInSecs: 0
                }
                entity.stats.forEach(element => {
                    for (const key of Object.keys(stats)) {
                        stats[key] += element[key]
                    }
                })
                return stats
            },
            getAverageStats(entity) {
                const stats = {
                    points: 0,
                    rebounds: 0,
                    assists: 0,
                    steals: 0,
                    turnovers: 0,
                    blockedShots: 0,
                    twoPointsMade: 0,
                    twoPointAttempts: 0,
                    threePointsMade: 0,
                    threePointAttempts: 0,
                    freeThrowsMade: 0,
                    freeThrowAttempts: 0,
                    offensiveRebounds: 0,
                    defensiveRebounds: 0,
                    personalFouls: 0,
                    playTimeInSecs: 0
                }
                const temp = entity.stats
                temp.forEach(element => {
                    for (const key of Object.keys(stats)) {
                        stats[key] += element[key]
                    }
                })

                Object.keys(stats).forEach(element => {
                    if (temp.length) {
                        stats[element] = stats[element] / temp.length
                    } else {
                        stats[element] = 0
                    }
                })
                return stats
            },
            scrollToStats() {
                this.$refs.stats.scrollIntoView({ behavior: 'smooth' })
            }
        }
    }
</script>

<style scoped>
.v-chip::before {
    background-color: white !important;
}

.selected-chip {
    color: white;
}
</style>
